import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Home from './pages/Home'
import GalleryPage from './pages/GalleryPage'
import AdminGallery from './pages/AdminGallery'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/galeria" element={<GalleryPage />} />
        <Route path="/admin/galeria" element={<AdminGallery />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
